<template>

  <mw-dialog size="mini_mini" ref="unitDialog" title="选择单位" :footerButton="unitFooterButton" :close-on-click-modal="false">
    <mw-tree :url="unitTreeUrl" :defaultParams="defaultParams" :autoLoad="false" :async="false" ref="unitTree" :selectNode="selectUnitId"
    :multiple="multiple" :expandedFirst="true"></mw-tree>
  </mw-dialog>


</template>
<script >
    export default {
        data() {
          return {
            defaultParams:{deep:true,isContainSelf:false,parentId:""},
            unitTreeUrl: 'api/org/getUnitTreeContainSelf',
            treeData:[],
            unitFooterButton: [
              {label: '确定', func: this.selectUnitSure},
              {label: '取消', func: this.selectUnitCancel,type: 'default'}
            ]
          }
        },
        props:{
           selectUnitId:{
             type: String,
             default: ''
           },
           multiple:{
             type: Boolean,
             default: false
           }
        },
        mounted() {
          var me = this;
        },
      methods:{
        //单位选择
      selectUnitSure() {
        let data = this.mwRef('unitTree').getSelected();
        if (!data) {
          this.mwMsg('warning', '请选择单位');
        } else {
         this.$emit("confirm");
         this.selectUnitCancel();
        }
      },
      selectUnitCancel() {
        this.mwRef('unitDialog').hide();
      },
      getValue(){

        return this.mwRef('unitTree').getSelected();
      },
      show(){
          this.mwRef('unitDialog').show();
      }

      }
    }
</script>




// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/unitDialog.vue